<template>
  <div class="bullet-steps-indicator">
    <div
      v-for="index in steps"
      :key="index"
      :class="['bullet-step', { active: index === currentStep }]"
    ></div>
  </div>
</template>

<script>
export default {
  name: "BulletStepsIndicator",
  props: {
    steps: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.bullet-steps-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing;
}

.bullet-step {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid $text;

  &.active {
    background-color: $primary;
  }
}
</style>
